import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import _ from 'lodash';

import { PubSubKeys, TicketStatuses } from '../../../../store/constants';
import { callTicket } from '../../../../store/actions/ticketsActions';

function AssistTicket({ ticket }) {
    const dispatch = useDispatch();
    const hostname = useSelector(state => state.auth.hostname);
    const supportDeskId = useSelector(state => state.auth.supportDeskId);
    const supportDesks = useSelector(state => state.services.supportDesks);
    const authenticatedUser = useSelector(state => state.auth.authenticatedUser);

    const manageTicket = (volume) => {
        const action = 'callTicket';
        const callType = 'next';
        const supportDesk = supportDesks.find(data => data.id === supportDeskId);

        // deep clone with lodash
        const user = _.cloneDeep(authenticatedUser);
        delete user.accessToken;
        delete user.refreshToken;
        delete user.branchId;
        delete user.email;
        delete user.status;

        const newTicket = {
            authenticatedUser: user,
            sessionStart: dayjs().unix(),
            volume,
            status: TicketStatuses[action],
            callType //next is to call the next available ticket or recall an active ticket : direct is to call ticket by its number
        };

        newTicket.manage = {
            supportDesk,
            userId: authenticatedUser.id,
        };

        const payload = {
            ...PubSubKeys[action],
            msg: {
                ticket: newTicket
            }
        };
        dispatch(callTicket(hostname, payload));
    };

    return (
        <div className={`home-left-content2-item item1 ${ticket.status ? 'nextTrackingMute' : 'nextTracking'}`} onClick={() => ticket.status ? null : manageTicket(-1)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="none" viewBox="0 0 61 60">
                <circle cx="30.5" cy="17.5" r="14.5" stroke="#fff" strokeWidth="4.287"/>
                <path stroke="#fff" strokeWidth="4.287" d="M58 60c0-15.464-12.312-28-27.5-28S3 44.536 3 60"/>
            </svg>
            <h4>Call</h4>
        </div>
    );
}

export default AssistTicket;